var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.3 26.3",
    style: {
      enableBackground: "new 0 0 26.3 26.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "inventory_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8,1.1H3.5c-1.2,0-2.4,1.1-2.4,2.4v3.6c0,0.9,0.5,1.6,1.2,2v13.6c0,1.3,1.3,2.4,2.4,2.4h16.8c1.1,0,2.4-1.1,2.4-2.4 V9.2c0.7-0.4,1.2-1.2,1.2-2V3.5C25.2,2.2,24,1.1,22.8,1.1z M21.6,22.8H4.8V9.6h16.8V22.8z M22.8,7.2H3.5V3.5h19.2V7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,13.2H9.6v2.4h7.2V13.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInventory);
export default __webpack_public_path__ + "static/media/icon_inventory.c22dbb42596d23d92808ec3bdb0b02de.svg";
export { ForwardRef as ReactComponent };